<template>
  <div class="page">
    <template v-if="data.state == 0 || data.state == -1 || editing">
      <template v-if="!submited">
        <div class="w1100 v-mt-lg">
          <div class="panel">
            <div class="panel-body">
              <a-form-model class="form-sm" ref="form" :model="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 16 }">
                <a-form-model-item :colon="false" v-if="data.state == -1">
                  <span slot="label"></span>
                  <a-alert class="v-mb-sm no-border" type="error">
                    <div slot="message">
                      <div class="font-md text-darkblue flex items-center">
                        <a-icon type="alert" class="v-mr-xs" />
                        此筹款申请已被驳回
                      </div>
                      <div class="flex v-mt-xs">
                        <span class="text-right text-grey">审核意见：</span>
                        <span class="col text-red" v-html="$utils.convertToHtml(data.checkOpinion)"></span>
                      </div>
                    </div>
                  </a-alert>
                </a-form-model-item>
                <!-- <a-divider class="bg-primary"></a-divider> -->
                <a-row>
                  <a-col span="24">
                    <a-form-model-item :colon="false" :label-col="{ span: 5 }" :wrapper-col="{ span: 16 }">
                      <span slot="label">
                        <i class="required-mark">*</i>
                        项目名称
                      </span>
                      <a-input v-model="form.prjName" ref="prjName" placeholder="建议15个字以内，情真意切" style="width: 100%" />
                    </a-form-model-item>
                  </a-col>
                </a-row>
                <a-row>
                  <a-col span="24">
                    <a-form-model-item :colon="false" :label-col="{ span: 5 }" :wrapper-col="{ span: 16 }">
                      <span slot="label">
                        <!-- <i class="required-mark">*</i> -->
                        公开募捐备案编号
                      </span>
                      <a-input disabled v-model="form.raiseNo" ref="raiseNo" placeholder="慈善中国备案编号" style="width: 100%" />
                    </a-form-model-item>
                  </a-col>
                </a-row>
                <!-- <a-row :gutter="0">
                <a-col span="12">
                  <a-form-model-item>
                    <span slot="label">
                      <i class="required-mark">*</i>
                      项目名称
                    </span>
                    <a-input v-model="form.prjName" ref="prjName" placeholder="建议15个字以内，情真意切" style="width: 100%" />
                  </a-form-model-item>
                </a-col>
                <a-col span="12">
                  <a-form-model-item :colon="false">
                    <span slot="label">公开募捐备案编号</span>
                    <a-input v-model="form.raiseNo" ref="raiseNo" placeholder="慈善中国备案编号" style="width: 100%" />
                  </a-form-model-item>
                </a-col>
              </a-row> -->
                <a-row :gutter="0">
                  <a-col span="24">
                    <a-form-model-item :colon="false" :label-col="{ span: 5 }" :wrapper-col="{ span: 16 }">
                      <span slot="label">
                        <i class="required-mark">*</i>
                        筹款目标
                      </span>
                      <a-radio-group v-model="form.raiseAmountType">
                        <a-radio :value="-1">不设定上限</a-radio>
                        <a-radio :value="1">
                          <a-input placeholder="输入金额" suffix="元" v-model="form.raiseAmount" :disabled="form.raiseAmountType !== 1" style="width: 160px"></a-input>
                        </a-radio>
                      </a-radio-group>
                    </a-form-model-item>
                  </a-col>
                </a-row>
                <a-row :gutter="0">
                  <a-col span="24">
                    <a-form-model-item :colon="false" :label-col="{ span: 5 }" :wrapper-col="{ span: 16 }">
                      <span slot="label">
                        <i class="required-mark">*</i>
                        结束时间
                      </span>
                      <a-radio-group v-model="form.endDateType">
                        <a-radio :value="-1">不限制时间</a-radio>
                        <a-radio :value="1">
                          <a-date-picker format="YYYY-MM-DD" value-format="YYYY-MM-DD" placeholder="选择日期" v-model="form.endDate" :disabled="form.endDateType !== 1" style="width: 130px" />
                        </a-radio>
                      </a-radio-group>
                    </a-form-model-item>
                  </a-col>
                </a-row>
                <a-row :gutter="0">
                  <a-col span="24">
                    <a-form-model-item :colon="false" :label-col="{ span: 5 }" :wrapper-col="{ span: 16 }">
                      <span slot="label">
                        <i class="required-mark">*</i>
                        支持人次上限
                      </span>
                      <a-radio-group v-model="form.peopleType">
                        <a-radio :value="-1">不限制人次</a-radio>
                        <a-radio :value="1">
                          <a-input placeholder="输入人数" suffix="个" v-model="form.people" :disabled="form.peopleType !== 1" style="width: 160px" />
                        </a-radio>
                      </a-radio-group>
                    </a-form-model-item>
                  </a-col>
                </a-row>
                <a-row>
                  <a-col span="24">
                    <a-form-model-item class="form-item-label-vtop" :colon="false" :label-col="{ span: 5 }" :wrapper-col="{ span: 16 }">
                      <span slot="label">
                        <i class="required-mark">*</i>
                        主图
                      </span>
                      <div class="ant-form-explain text-grey v-mb-xs" style="margin-top: 1px">支持jpg/png/gif格式，图片尺寸建议为750x450像素，大小不超过2MB</div>
                      <a-upload
                        :action="`${baseURL}/file/upload`"
                        :data="{
                          params: JSON.stringify({ projectId, raiseId, fileType: 101, fileSign: 'PR' }),
                        }"
                        :file-list="bannerFiles"
                        :before-upload="beforeUploadFile"
                        @preview="handlePreviewFile"
                        @change="info => handleUploadChange(info, 1, 'bannerFiles')"
                        list-type="picture-card"
                        class="picture-uploader picture-uploader-zt"
                        accept=".png, .jpg, .jpeg, .gif"
                        ref="bannerFiles"
                      >
                        <div v-if="bannerFiles.length === 0">
                          <a-icon type="plus" />
                          <div class="ant-upload-text">上传主图</div>
                        </div>
                      </a-upload>
                    </a-form-model-item>
                  </a-col>
                  <a-col span="24">
                    <a-form-model-item :colon="false" :label-col="{ span: 5 }" :wrapper-col="{ span: 16 }">
                      <span slot="label">
                        <!-- <i class="required-mark">*</i> -->
                        隐藏筹款名称
                      </span>
                      <div class="flex items-center"><a-switch v-model="form.isHiddenName" /><span class="v-ml-xs">开启后筹款名称将不在页面头图下显示</span></div>
                    </a-form-model-item>
                  </a-col>
                </a-row>
                <a-row>
                  <a-col span="24">
                    <a-form-model-item :colon="false" :label-col="{ span: 5 }" :wrapper-col="{ span: 16 }">
                      <span slot="label">
                        <i class="required-mark">*</i>
                        详情
                      </span>
                      <!-- <a-textarea :auto-size="{ minRows: 10 }" v-model="form.content" ref="content" placeholder="详情" style="width: 100%" /> -->
                      <!-- <div class="ant-form-explain text-grey text-justify">项目的执行效果，35个汉字以内，该内容会展示在捐款前提示中</div> -->
                      <tinymce id="myedit" ref="editor" v-model="form.content" :file-params="{ projectId, raiseId, fileType: 102, fileSign: 'PR' }" />
                    </a-form-model-item>
                  </a-col>
                </a-row>
              </a-form-model>
            </div>
          </div>
          <div class="text-center v-mt-sm v-mb-lg">
            <a-space>
              <!-- <a-button icon="swap-left" type="indigo" @click="currentStep = 0">返回上一步</a-button> -->
              <a-button icon="check" type="primary" @click="handleConfirm" :loading="saving">提交筹款申请信息</a-button>

              <a-button icon="close" type="default" @click="load" v-if="editing">取消编辑</a-button>
              <a-button icon="undo" type="indigo" @click="handleReset" v-else>重置</a-button>
            </a-space>
          </div>
        </div>
      </template>
      <template v-else>
        <a-result status="success" title="提交成功" sub-title="您填报的筹款申请信息已提交，请耐心等待审核结果。">
          <template #extra>
            <a-button key="view" type="primary" @click="load">查看已提交信息</a-button>
          </template>
        </a-result>
      </template>
    </template>
    <template v-else-if="[1, 2, 3].includes(data.state)">
      <div class="w960 v-mt-lg">
        <div class="panel">
          <div class="panel-body">
            <a-alert banner :show-icon="false" class="v-mb-sm" type="warning"  v-if="data.state == 1">
              <div slot="message" class="text-grey">此筹款申请于 {{ data.applyTime }} 提交，<a-button icon="form" type="indigo" size="small" @click="editing = true">重新编辑</a-button></div>
            </a-alert>
            <table class="table table-plain">
              <tbody>
                <tr>
                  <th width="150">项目名称</th>
                  <td width="32%">{{ form.prjName }}</td>
                  <th width="150">公开募捐备案编号</th>
                  <td>{{ form.raiseNo }}</td>
                </tr>
                <tr>
                  <th>筹款目标</th>
                  <td>
                    <template v-if="form.raiseAmountType == -1">不设定上限</template>
                    <template v-else>{{ $utils.thousands(form.raiseAmount, 0) }} 元</template>
                  </td>
                  <th>结束时间</th>
                  <td>
                    <template v-if="form.endDateType == -1">不限制时间</template>
                    <template v-else>{{ form.endDate }}</template>
                  </td>
                </tr>
                <tr>
                  <th>支持人次上限</th>
                  <td>
                    <template v-if="form.peopleType == -1">不限制人次</template>
                    <template v-else>{{ form.people }}</template>
                  </td>
                  <th>隐藏筹款名称</th>
                  <td>
                    <template v-if="form.isHiddenName">隐藏</template>
                    <template v-else>显示</template>
                    （隐藏后筹款名称将不在页面头图下显示）
                  </td>
                </tr>
                <tr>
                  <th valign="top">主图</th>
                  <td colspan="3">
                    <file-container :img-size="[220, 120]" :files="data.files" :belongId="raiseId" fileSign="PR" v-if="data.files && raiseId"></file-container>
                  </td>
                </tr>
                <tr>
                  <th valign="top">详情</th>
                  <td colspan="3" v-html="form.content"></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import tinymce from '@/components/tinymce'
import { submitRaise, getRaise } from '@/api/project/funded'
import { LX_FORM_CONTENT } from '@/utils/raise'
const form = {
  prjName: '',
  raiseNo: '',
  raiseAmountType: -1,
  raiseAmount: undefined,
  endDateType: -1,
  endDate: undefined,
  peopleType: -1,
  people: undefined,
  isHiddenName: false,
  content: '',
}
export default {
  props: {
    raiseId: {
      type: Number,
      required: true,
    },
  },
  components: {
    tinymce,
  },
  data() {
    return {
      projectId: undefined,
      // raiseId: null,
      // currentStep: 0,
      submited: false,
      editing: false,
      saving: false,
      data: {},
      form: {
        ...form,
      },
      bannerFiles: [],
    }
  },
  methods: {
    load() {
      this.loading = true
      this.editing = false
      getRaise(this.raiseId).then(({ data }) => {
        if (data.success) {
          let result = data.result
          let { projectId, raiseInfo, raiseNo, files } = result
          this.form = { ...form, ...JSON.parse(raiseInfo || '{}') }
          if (raiseNo) {
            this.form.raiseNo = raiseNo
          }
          this.bannerFiles = files
            .filter(file => file.fileType === 101)
            .map(file => ({
              uid: file.fileId,
              name: file.fileOriginName,
              status: 'done',
              fileSign: 'PR',
              belongId: file.raiseId,
              ...file,
              url: `${this.baseURL}/file/img?id=${file.fileId}&belongId=${file.raiseId}&fileSign=PR`,
            }))
          this.data = result
          this.projectId = projectId
          this.submited = false
        }
      })
    },
    handleConfirm() {
      this.$message.destroy()
      let { prjName, content } = this.form
      if (prjName.trim() === '') {
        this.$message.warning('请输入项目名称')
        this.$refs.prjName.focus()
        return
      }
      if (this.bannerFiles.length === 0) {
        this.$message.warning('请上传主图')
        this.$refs.bannerFiles.$el.classList.add('uploader-empty')
        return
      }
      if (content.trim() === '') {
        this.$message.warning('请输入详情')
        return
      }
      this.$confirm({
        title: '确认提交筹款申请信息？',
        centered: true,
        onOk: () => {
          this.handleSubmit()
        },
      })
    },
    handleSubmit() {
      this.saving = true
      let params = {
        files: this.bannerFiles.map(({ fileId }) => ({ fileId })),
        raiseId: this.raiseId,
        raiseInfo: JSON.stringify(this.form),
        projectId: this.projectId,
      }
      this.$message.destroy()
      submitRaise(params).then(({ data }) => {
        this.saving = false
        if (data.success) {
          this.submited = true
          this.$emit('submit')
        } else {
          this.$message.warning(data.msg)
        }
      })
    },
    handleReset() {},
    handleUploadChange(info, count, ref) {
      if (ref && this.$refs[ref]) {
        this[ref] = this.handleUploadFile(info, count)
        this.$refs[ref].$el.classList.remove('uploader-empty')
      }
    },
  },
  created() {
    this.load()
  },
}
</script>
